import React from 'react';
import './SocialMedia.css';
import { SOCIAL_MEDIA } from '../../../constants/enums';

const SocialMedia = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="social-media-container">
      <div className="social-media-buttons">
        <a 
          href={SOCIAL_MEDIA.FACEBOOK}
          target="_blank" 
          rel="noopener noreferrer"
          className="social-button facebook-button"
          title="Facebook"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
          <span className="social-text">FACEBOOK</span>
        </a>
        
        <a 
          href={SOCIAL_MEDIA.INSTAGRAM}
          target="_blank" 
          rel="noopener noreferrer"
          className="social-button instagram-button"
          title="Instagram"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
        </a>
        
        <a 
          href={SOCIAL_MEDIA.TIKTOK}
          target="_blank" 
          rel="noopener noreferrer"
          className="social-button tiktok-button"
          title="TikTok"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="social-icon">
            <path d="M19.321 5.562c-.756-.423-1.3-.952-1.691-1.473-.522-.696-.861-1.455-.861-2.089v-.5c0-.276-.224-.5-.5-.5h-3.5c-.276 0-.5.224-.5.5v11.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5 1.119-2.5 2.5-2.5c.276 0 .5-.224.5-.5v-3.5c0-.276-.224-.5-.5-.5-3.59 0-6.5 2.91-6.5 6.5s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5v-5.724c.555.32 1.182.724 1.904.724.276 0 .5-.224.5-.5v-3.5c0-.276-.224-.5-.5-.5-.447 0-.862-.103-1.179-.438z"/>
          </svg>
        </a>
        
        <button 
          className="scroll-up-button"
          onClick={scrollToTop}
          title="Scroll to top"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="scroll-icon">
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SocialMedia;